import classnames from 'classnames';
import PropTypes from 'prop-types';

import ChevronDown from './icon/ChevronDown';

const ExpandContentSymbol = ({ active, variant }) => (
  <span
    className={classnames('expand-content-symbol', {
      'expand-content-symbol--active': active,
      'expand-content-symbol--white': variant === 'white',
      'expand-content-symbol--grey': variant === 'grey',
      'expand-content-symbol--bluegrey': variant === 'bluegrey',
    })}
  >
    <ChevronDown />
  </span>
);

ExpandContentSymbol.propTypes = {
  active: PropTypes.bool.isRequired,
  variant: PropTypes.oneOf(['white', 'grey', 'bluegrey']).isRequired,
};

export default ExpandContentSymbol;
